import React from 'react';
import BottomSheetDatePicker from 'Components/BottomSheetDatePicker';
import { Controller } from 'react-hook-form'

const BottomSheetDatePickerInput = (props: any) => {
    return (
        <React.Fragment>
            <Controller
                name={props.name}
                control={props.control}
                rules={{
                    ...props.rules,
                    validate: (e) => {
                        if (props?.rules['required'] == true) {
                            let message = ""
                            if (e == "Invalid Date")
                                message += "date,"

                            return message == "" ? true : message
                        } else
                            return true
                    }
                }}
                render={({ field: { onChange, value },
                    fieldState: { error },
                    formState }) => {
                    return <BottomSheetDatePicker
                        onChange={onChange} value={value} {...props}
                    />;
                }} />
        </React.Fragment>
    )
}

export default BottomSheetDatePickerInput;